import React from 'react';
import { IconProps } from './types';

const AgencyIcon: React.FC<IconProps> = props => {
  const { height = '24', width = '24', fillColor = 'var(--greyscale-5)' } = props;
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.4099 15.4224H20.0899"
        stroke={fillColor}
        strokeWidth="1.2"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
      <path
        d="M14.4099 20.9924H20.0899"
        stroke={fillColor}
        strokeWidth="1.2"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
      <path
        d="M14.4099 18.2124H20.0899"
        stroke={fillColor}
        strokeWidth="1.2"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
      <path
        d="M11.1299 20.9927H4.10991C3.99946 20.9927 3.90991 20.9032 3.90991 20.7927V3.26162C3.90991 3.13064 4.03373 3.03501 4.16047 3.06812L16.2005 6.21362C16.2885 6.23662 16.3499 6.31614 16.3499 6.40712V12.5927"
        stroke={fillColor}
        strokeWidth="1.2"
        strokeMiterlimit="10"
      />
      <path
        d="M14.4099 15.4224H20.0899"
        stroke={fillColor}
        strokeWidth="1.2"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
      <path
        d="M8.67002 9.13232H6.97002C6.85956 9.13232 6.77002 9.22187 6.77002 9.33232V11.1423C6.77002 11.2527 6.85956 11.3423 6.97002 11.3423H8.67002C8.78048 11.3423 8.87002 11.2527 8.87002 11.1423V9.33232C8.87002 9.22187 8.78048 9.13232 8.67002 9.13232Z"
        fill={fillColor}
      />
      <path
        d="M13.2999 9.13232H11.5999C11.4895 9.13232 11.3999 9.22187 11.3999 9.33232V11.1423C11.3999 11.2527 11.4895 11.3423 11.5999 11.3423H13.2999C13.4104 11.3423 13.4999 11.2527 13.4999 11.1423V9.33232C13.4999 9.22187 13.4104 9.13232 13.2999 9.13232Z"
        fill={fillColor}
      />
      <path
        d="M8.67002 13.7925H6.97002C6.85956 13.7925 6.77002 13.8821 6.77002 13.9925V15.8025C6.77002 15.913 6.85956 16.0025 6.97002 16.0025H8.67002C8.78048 16.0025 8.87002 15.913 8.87002 15.8025V13.9925C8.87002 13.8821 8.78048 13.7925 8.67002 13.7925Z"
        fill={fillColor}
      />
    </svg>
  );
};

export default AgencyIcon;
